<template>
  <list-table
    :url="url"
    title="لیست مدیران"
    :detailUrl="detailUrl"
     :newUrl="newUrl"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
export default {
  name: "Users",
  data() {
    return {
      url: "users",
      params: [
        {
          label: "پست الکترونیکی",
          field: "email",
          type: "text",
        },
        {
          label: "تلفن همراه",
          field: "mobile",
          type: "text",
        },
      ],
      fields: [
        {
          key: "id",
          label: "کد"
        },
        {
          key: "name",
          label: "نام"
        },
        {
          key: "email",
          label: "پست الکترونیکی"
        },
        {
          key: "roles.name",
          label: "سمت"
        },
        {
          key: "details",
          label: "عملیات"
        }
      ],
       detailUrl: "editUser",
       newUrl: "addUser",
    };
  },
  components: {
    "list-table": TableShowData,
  },
   methods: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست مدیران" }]);
  }
};
</script>